import React, { Component } from 'react'
import querystring from 'query-string'
import { connect } from 'react-redux'
import 'whatwg-fetch'

import { receiveItems, searchKeyword, clearItems } from '../../../actions/contents/page';
import PageListItem from './PageListItem'
import { parseListParams } from '../../common/EntryListHelper';
import LoadErrorBox from "../../../components/common/LoadErrorBox";
import * as InitStatus from '../../../constants/common/InitializationStatus';
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import LoadingBox from "../../common/LoadingBox";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    items: state.page.item.items,
    condition: state.page.condition,
}), dispatch => ({
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleSearch: (keyword, type) => {
        dispatch(searchKeyword(keyword, type))
    },
    handleClearItems: () => {
        dispatch(clearItems())
    },
    dispatch
}))
class PageContent extends Component {

	constructor(props, context) {
		super(props, context);

		let listParams = parseListParams(props.location.search)

		this.state = {
            initialized : InitStatus.INIT_READY,
			currentPage: listParams.page,
            currentSearchKeyword : listParams.searchKeyword,
            currentSearchType : listParams.searchType,
		}
        this.init = this.init.bind(this);
        this.fetchPages = this.fetchPages.bind(this);
    }

	componentDidMount() {
        this.init();
	}

    componentWillReceiveProps(nextProps) {

        const { currentPage, currentSearchKeyword, currentSearchType } = this.state;
		let listParams = parseListParams(nextProps.location.search)

        if (currentPage !== listParams.page
            ||
            currentSearchKeyword !== listParams.searchKeyword
            ||
            currentSearchType !== listParams.searchType
        ) {

            this.fetchPages(listParams.page, listParams.searchKeyword, listParams.searchType );
            this.setState({
                currentPage: listParams.page,
                currentSearchKeyword : listParams.searchKeyword,
                currentSearchType : listParams.searchType,
            });
        }
    }

    componentWillUnmount() {
        this.props.handleClearItems();
    }

    init() {
        const { currentPage, currentSearchKeyword, currentSearchType} = this.state;

        const { dispatch } = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/pages.json?") + querystring.stringify({
            page: currentPage,
            searchKeyword: currentSearchKeyword,
            searchType: currentSearchType,
        }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount);
                this.props.handleSearch(currentSearchKeyword, currentSearchType);
                this.setState({
                    initialized : InitStatus.INIT_SUCCESS,
                    currentPage: currentPage
                })
            })
            .catch(e => {
                console.error(e);
                this.props.handleReceiveItems([], 0);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                })
            })

    }

    fetchPages(page, searchKeyword, searchType) {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/pages.json?") + querystring.stringify({
			page: page,
			searchKeyword: searchKeyword,
            searchType: searchType,
		}), {
			method: 'GET',
			credentials: 'include'
		})
            .then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				this.props.handleReceiveItems(data.items, data.totalCount);
				this.props.handleSearch(searchKeyword, searchType);
				this.setState({
					currentPage: page
				})
            })
			.catch(e => {
                console.error(e);
				this.props.handleReceiveItems([], 0);
            })
	}

	render() {
		const { items } = this.props;

		return (
			<div className="wrap_list">
				<ul className="list_post list_post_type2">
                    { this.renderItems(items) }
				</ul>
			</div>
		)
	}

    renderEmptyItems() {

        const { condition } = this.props;
        const { searchKeyword } = condition;
        if(searchKeyword === '' ) {
            return <li className="info_none">
				<div className="txt_none">
					<span className="wrap_ico"><span className="ico_blog ico_post"/></span>
					아직 등록된 페이지가 없습니다.
				</div>
				<a href={addPrefix("/manage/page")} className="link_none">새 페이지 쓰기</a>
			</li>
        }else{
            return <li className="info_none">
				<div className="txt_none">
					<span className="wrap_ico"><span className="ico_blog ico_search"/></span>
					검색 결과가 없습니다.
				</div>
			</li>
        }
    }

    renderItems(items) {
        const {initialized} = this.state;

        if (initialized === InitStatus.INIT_DOING ) {
            return (<li className="info_none">
				<LoadingBox/>
			</li>);
        }else if(initialized === InitStatus.INIT_FAIL ){
            return (
				<LoadErrorBox retry={this.init}/>
            );
        }else if(initialized === InitStatus.INIT_SUCCESS ) {

            if(items.length === 0 ){
                return this.renderEmptyItems(items);
            }else{
                return items.map(item =>
					<PageListItem key={item.id} item={item} />
                )
            }
        }
	}
}

export default PageContent;
